const Translations = {
  EN: require('./en.json'),
  FR: require('./fr.json'),
  DE: require('./de.json'),
}

export type TranslationsType = typeof Translations.EN
export type TranslationsId = keyof TranslationsType

export default Translations
